module.exports = __webpack_public_path__ + "static/media/default-image.8907ae79.jpg";